angular.module('bmsApp.settings').factory('WebexInteractSvc', function ($http, $log, $window, $q, CRUDSvc, APP_WEBEX_INTERACT_API) {

	return {
		sendVerificationCode: function (data) {return CRUDSvc.post(APP_WEBEX_INTERACT_API.sendVerificationCode, data);},
		verifyAndSave: function (data) {return CRUDSvc.post(APP_WEBEX_INTERACT_API.verifyAndSave, data);},
	}

}).constant('APP_WEBEX_INTERACT_API', {
	sendVerificationCode: 'api/settings/webex-interact/send-verification-code',
	verifyAndSave: 'api/settings/webex-interact/verify-and-save',
});




